import React from 'react';

const TableDomains = ({tableItems}) => {
  return (
    <table className='table__domains'>
      <thead>
      <tr className='iransans-m table__domains__head'>
        <th style={{width: "33px"}}>ردیف</th>
        <th style={{width: "70px"}}>کد دامنه</th>
        <th style={{width: "126px"}}>نام دامنه</th>
        <th style={{width: "126px"}}>کد ورژن</th>
        <th>محدوده</th>
      </tr>
      </thead>
      <tbody>
      {tableItems ? tableItems.map((item, index) => (
        <tr key={index} className='iransans-b table__domains__desc'>
          <td>{index + 1}</td>
          <td>{item.id}</td>
          <td>{item.name}</td>
          <td>{item.version}</td>
          <td>{item.domainDescription}</td>
        </tr>

      )) : null}
      </tbody>
    </table>
  );
};

export default TableDomains;